import { makeStyles } from 'tss-react/mui';

const useStylesTableCell: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme, props: MaterialUIStylesProps,
): MaterialUIStyles => ({
  tableCell: {
    width: props.width || 'auto',
  },
  tableCellText: {
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },
  tableCellTextMultiline: {
    whiteSpace: 'pre-wrap',
  },
  tableCellTextLeft: {
    textAlign: 'left !important',
  },
  tableCellTextRight: {
    textAlign: 'right !important',
  },
  tableCellTextCenter: {
    textAlign: 'center !important',
  },
  tableCellTextNormal: {
    fontWeight: 'normal !important',
  },
  tableCellTextNoWrap: {
    whiteSpace: 'nowrap !important',
  },
  tableCellTextWrap: {
    whiteSpace: 'normal !important',
  },
  tableCellNumber: {
    textAlign: 'right !important',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  tableCellHeader: {
    fontWeight: '500 !important',
  },
  tableCellActions: {
    minWidth: '100px !important',
    paddingRight: '10px !important',
  },
  tableCellDisabled: {
    color: `${theme.palette.action.disabled} !important`,
  },
  tableCellButton: {
    cursor: 'pointer !important',
  },
  tableCellNoPadding: {
    padding: '0 !important',
  },
  tableCellNoFixedSize: {
    minWidth: '50px !important',
  },
  tableCellSmallPadding: {
    padding: '10px !important',
  },
  tableCellActive: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
  },
  tableCellActiveText: {
    color: `${theme.palette.secondary.main} !important`,
    fontWeight: '500 !important',
  },
  tableCellDark: {
    color: `${theme.palette.primary.dark} !important`,
  },
  tableCellSticky: {
    position: 'sticky',
    background: 'inherit',
    zIndex: '14 !important',
  },
  tableCellStickyLeft: {
    left: 0,
    zIndex: '14 !important',
    'th&': {
      zIndex: '29 !important',
    },
  },
  tableCellStickyLeftSelect: {
    left: 100,
    'th&': {
      zIndex: '28 !important',
    },
  },
  tableCellStickyLeftSelectExtended: {
    left: 133,
    'th&': {
      zIndex: '28 !important',
    },
  },
  tableCellStickyLeftHeader: {
    zIndex: '16 !important',
  },
  tableCellStickyRight: {
    right: 0,
  },
  tableCellStickyRightHeader: {
    zIndex: '16 !important',
  },
  tableCellStickyGroupLeft: {
    'th&': {
      zIndex: '40 !important',
    },
  },
  tableCellStickyGroupLeftSelect: {
    'th&': {
      zIndex: '39 !important',
    },
  },
  tableCellStickyGroupRight: {
    'th&': {
      zIndex: '40 !important',
    },
  },
}));

export default useStylesTableCell;
